module.exports = __webpack_public_path__ + "static/media/ramco.814220a0.svg";